export default __webpack_public_path__ + "static/media/773.5dae0c04.png";